/**
 * Establishes a Supabase session from auth callback URLs on web when detectSessionInUrl is off.
 * Used on /reset-password (recovery) and any route that receives PKCE codes or implicit hash tokens.
 */

import { supabase } from '../../lib/supabase'
import { parseSupabaseOAuthRedirectUrl } from './signInApi'
import { exchangeOAuthCodeForSessionOnce, extractOAuthAuthCodeFromCallbackUrl } from './oauthPkceExchange.helper'

export type EstablishWebAuthSessionResult = {
  ok: boolean
  skipped: boolean
}

/**
 * PKCE query `code=` takes precedence; otherwise implicit hash tokens (recovery / legacy).
 */
export async function establishWebAuthSessionFromCallbackUrl(
  callbackUrl: string,
): Promise<EstablishWebAuthSessionResult> {
  if (extractOAuthAuthCodeFromCallbackUrl(callbackUrl)) {
    const result = await exchangeOAuthCodeForSessionOnce(callbackUrl)
    return { ok: result.ok, skipped: result.skipped }
  }

  const tokens = parseSupabaseOAuthRedirectUrl(callbackUrl)
  if (!tokens) {
    return { ok: false, skipped: true }
  }

  const { error } = await supabase.auth.setSession(tokens)
  return { ok: !error, skipped: false }
}
